<div class="card-container" [style.background-image]="'url(' + ( $safeNavigationMigration(plpBanner.image?.image?.url)! | imageSize : 600) + ')'">
    <a [href]="plpBanner.link?.link ?? '#'"
       [attr.target]="linkTarget"
       class="card-link"
    >
        <div class="card-info">
            <h4 class="card-title">
                {{ plpBanner.title }}
            </h4>

            <p class="card-description">
                {{ plpBanner.description }}
            </p>

            @if (plpBanner.link; as link) {
                @if (link.label) {
                    <app-button layout="label-only"
                    >
                        {{ link.label }}
                    </app-button>
                }
            }
        </div>
    </a>
</div>
